var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-over-btn"},[_c('router-link',{attrs:{"to":{ name: 'kpi.home', query: { activity_id: _vm.activity_id, user_id: _vm.user_id, kpi_uid: _vm.kpi_userid, share_uid: _vm.share_userid,act_id: _vm.act_id }}}},[_c('img',{attrs:{"src":"https://j.weizan.cn/youxiang/images/home-over.png"}}),_vm._v(" 首页 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }